export const featureList = [
    {key: "reports", label: "Reports"},
    {key: "rowsPerReport", label: "Max rows per report"},
    {key: "team", label: "Team members"},
    {key: "databases", label: "Databases"},
    {key: "reportFrequency", label: "Reporting Frequency"},
    {key: "customIntegrations", label: "Custom Data Integrations"},
    {key: "support", label: "Support Level"},
    // {key: "freeConsultingHours", label: "Free consulting hours [BETA]"},
];